import { IndividuelListe } from "./IndividuelListe";
import "./IndividuelListe.scss";

export default IndividuelListe;
